import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { 
  Home, ArrowUpCircle, ArrowDownCircle, Send, History, User, Settings, 
  Shield, LogOut, Bell, CheckCircle, Star, Mail, Phone, MapPin, 
  Globe, Clock, Monitor, Smartphone, Calendar, Edit2, Lock
} from "lucide-react";

// Browser Frame Component
// Browser Frame Component with theme support
const BrowserFrame = ({ theme = 'light' }) => {
  const isLight = theme === 'light';
  const bgColor = isLight ? '#dee1e6' : '#202124';
  const tabBgInactive = isLight ? '#f1f3f4' : '#35363a';
  const tabBgActive = isLight ? '#fff' : '#292a2d';
  const textColor = isLight ? '#5f6368' : '#9aa0a6';
  const textColorActive = isLight ? '#202124' : '#e8eaed';
  const addressBarBg = isLight ? '#f1f3f4' : '#35363a';
  
  return (
    <div className="flex-shrink-0" style={{ backgroundColor: bgColor }}>
      <div className="flex items-center h-[38px]" style={{ backgroundColor: bgColor }}>
        <div className="flex items-end flex-1 pl-2">
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: tabBgInactive }}>
            <img src="https://finance.ozon.ru/favicon.ico" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
            <span className="text-[13px] truncate flex-1" style={{ color: textColor }}>Ozon Карта</span>
          </div>
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: tabBgActive }}>
            <img src="https://customer-assets.emergentagent.com/job_task-master-543/artifacts/g6wnx4m7_image.png" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
            <span className="text-[13px] truncate flex-1" style={{ color: textColorActive }}>ONESIX Profile</span>
          </div>
          <button className="w-7 h-7 flex items-center justify-center rounded-full ml-1 mb-1" style={{ color: textColor }}>
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          </button>
        </div>
        <div className="flex items-center h-full">
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#c8cace]" style={{ color: textColor }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#c8cace]" style={{ color: textColor }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: textColor }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
        </div>
      </div>
      <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: tabBgActive }}>
        <div className="flex items-center gap-1 mr-2">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: isLight ? '#dadce0' : '#5f6368' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg></button>
        </div>
        <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: addressBarBg }}>
          <svg className="w-4 h-4 mr-3 flex-shrink-0" style={{ color: textColor }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
          <span className="text-[14px]" style={{ color: textColorActive }}>onesix.io/profile</span>
        </div>
        <div className="flex items-center gap-1 ml-3">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/><circle cx="12" cy="19" r="2"/></svg></button>
        </div>
      </div>
    </div>
  );
};

export default function NovapayPersonal() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [showBrowser, setShowBrowser] = useState(true);
  const [browserTheme, setBrowserTheme] = useState('light');

  useEffect(() => {
    const dataParam = searchParams.get('data');
    const browserParam = searchParams.get('showBrowser');
    const themeParam = searchParams.get('theme');
    
    if (browserParam !== null) {
      setShowBrowser(browserParam !== 'false');
    }
    if (themeParam) {
      setBrowserTheme(themeParam);
    }
    
    if (dataParam) {
      try {
        const parsed = JSON.parse(decodeURIComponent(dataParam));
        setData(parsed);
        if (parsed.showBrowser !== undefined) {
          setShowBrowser(parsed.showBrowser);
        }
        if (parsed.browserTheme) {
          setBrowserTheme(parsed.browserTheme);
        }
      } catch (e) {
        console.error("Error parsing data:", e);
      }
    }
  }, [searchParams]);

  if (!data) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-600 via-blue-600 to-indigo-700 flex items-center justify-center">
        <div className="text-white text-lg">Загрузка...</div>
      </div>
    );
  }

  // Generate patronymic if not present
  const generatePatronymic = (firstName) => {
    const malePatronymics = [
      'Александрович', 'Алексеевич', 'Андреевич', 'Артёмович', 'Борисович',
      'Вадимович', 'Валерьевич', 'Васильевич', 'Викторович', 'Витальевич',
      'Владимирович', 'Геннадьевич', 'Дмитриевич', 'Евгеньевич', 'Иванович',
      'Игоревич', 'Ильич', 'Константинович', 'Леонидович', 'Максимович',
      'Михайлович', 'Николаевич', 'Олегович', 'Павлович', 'Петрович',
      'Романович', 'Сергеевич', 'Станиславович', 'Тимофеевич', 'Юрьевич'
    ];
    const femalePatronymics = [
      'Александровна', 'Алексеевна', 'Андреевна', 'Артёмовна', 'Борисовна',
      'Вадимовна', 'Валерьевна', 'Васильевна', 'Викторовна', 'Витальевна',
      'Владимировна', 'Геннадьевна', 'Дмитриевна', 'Евгеньевна', 'Ивановна',
      'Игоревна', 'Ильинична', 'Константиновна', 'Леонидовна', 'Максимовна',
      'Михайловна', 'Николаевна', 'Олеговна', 'Павловна', 'Петровна',
      'Романовна', 'Сергеевна', 'Станиславовна', 'Тимофеевна', 'Юрьевна'
    ];
    const name = (firstName || '').trim();
    const lastChar = name.slice(-1).toLowerCase();
    const isFemale = lastChar === 'а' || lastChar === 'я' || lastChar === 'ь' && ['Любовь','Нинель'].some(n => name.startsWith(n));
    const femaleNames = ['Анна','Мария','Елена','Ольга','Наталья','Татьяна','Ирина','Светлана','Екатерина','Юлия','Анастасия','Дарья','Алина','Валерия','Кристина','Полина','Виктория','Софья','София','Зоя','Нина','Оксана','Любовь','Надежда','Вера','Галина','Людмила','Лариса','Тамара','Маргарита','Алла','Жанна','Инна','Диана','Карина','Марина','Елизавета','Евгения','Александра'];
    const isFem = femaleNames.some(n => name.toLowerCase() === n.toLowerCase()) || (isFemale && !['Никита','Илья','Кузьма','Фома','Лука','Данила','Саша','Миша','Алёша'].some(n => name.toLowerCase() === n.toLowerCase()));
    // Use a hash of the name for consistent patronymic
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = ((hash << 5) - hash) + name.charCodeAt(i);
      hash |= 0;
    }
    const list = isFem ? femalePatronymics : malePatronymics;
    return list[Math.abs(hash) % list.length];
  };

  const firstName = data.firstName || '';
  const lastName = data.lastName || '';
  const fullNameParts = (data.fullName || `${firstName} ${lastName}`).trim().split(/\s+/);
  // Generate patronymic if not present
  const patronymic = data.patronymic || ""
  let displayLastName = lastName;
  let displayFirstName = firstName;
  let displayPatronymic = patronymic;  // Use patronymic from Ozon profile if available
  if (!displayPatronymic) {
    if (fullNameParts.length <= 2 && firstName) {
      displayPatronymic = generatePatronymic(firstName);
  } else if (fullNameParts.length >= 3) {
      displayFirstName = fullNameParts[0];
      displayPatronymic = fullNameParts[1];
      displayLastName = fullNameParts.slice(2).join(' ');
  }
  }
  const accountNameShort = `${displayLastName} ${displayFirstName}`.trim() || 'Пользователь';
  const initials = `${displayLastName[0] || ''}${displayFirstName[0] || ''}`.toUpperCase();
  const userId = data.novapayId || Math.floor(100000 + Math.random() * 900000);
  const ipLogins = data.ipLogins || [];

  const menuItems = [
    { icon: Home, label: 'Главная', id: 'main' },
    { icon: ArrowUpCircle, label: 'Пополнить', id: 'deposit' },
    { icon: ArrowDownCircle, label: 'Вывести', id: 'withdraw' },
    { icon: Send, label: 'Перевод', id: 'transfer' },
    { icon: History, label: 'История', id: 'history' },
    { icon: User, label: 'Профиль', id: 'profile', active: true },
    { icon: Shield, label: 'Безопасность', id: 'security' },
    { icon: Settings, label: 'Настройки', id: 'settings' },
  ];

  // Generate device types for login history
  const getDeviceIcon = (index) => {
    return index % 2 === 0 ? Monitor : Smartphone;
  };

  const getDeviceName = (index) => {
    const devices = ['Windows 10', 'macOS Sonoma', 'iPhone 15 Pro', 'Android 14', 'Windows 11'];
    return devices[index % devices.length];
  };

  const getBrowserName = (index) => {
    const browsers = ['Chrome 120', 'Safari 17', 'Firefox 121', 'Edge 120', 'Opera 105'];
    return browsers[index % browsers.length];
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#f8fafc', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {showBrowser && <BrowserFrame theme={browserTheme} />}
      <div className="flex-1 flex bg-slate-50">
      {/* Sidebar */}
      <aside className="w-64 bg-gradient-to-b from-violet-600 via-blue-600 to-indigo-700 flex flex-col shadow-2xl">
        {/* Logo */}
        <div className="p-5 border-b border-white/10">
          <div className="flex items-center justify-center">
            <img src="/onesix-logo-white.svg" alt="ONESIX Crypto Wallet" className="h-10 object-contain" />
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 overflow-y-auto">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                className={`w-full flex items-center gap-3 px-5 py-3 text-sm transition-all ${
                  item.active 
                    ? 'bg-white/20 text-white border-r-4 border-white' 
                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-white/10">
          <button className="w-full flex items-center gap-3 px-4 py-2.5 text-blue-200 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
            <LogOut className="w-5 h-5" />
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between shadow-sm">
          <div>
            <h2 className="text-xl font-bold text-slate-800">Персональные данные</h2>
            <p className="text-slate-500 text-sm">Управление профилем и безопасностью</p>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span className="text-green-700 text-sm font-medium">Верифицирован</span>
            </div>
            
            <button className="p-2 text-slate-500 hover:text-slate-700 relative">
              <Bell className="w-5 h-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
            
            <div className="flex items-center gap-3 pl-4 border-l border-slate-200">
              <div className="w-9 h-9 bg-gradient-to-br from-violet-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-sm font-bold">
                  {initials}
                </span>
              </div>
              <div>
                <p className="text-sm font-medium text-slate-800">{accountNameShort}</p>
                <p className="text-xs text-slate-500">ID: {userId}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-auto bg-slate-50">
          <div className="grid grid-cols-2 gap-6">
            {/* Profile Card */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="bg-gradient-to-r from-violet-600 via-blue-600 to-indigo-600 p-6">
                <div className="flex items-center gap-4">
                  <div className="w-20 h-20 bg-white/20 backdrop-blur rounded-2xl flex items-center justify-center">
                    <span className="text-white text-2xl font-bold">
                      {initials}
                    </span>
                  </div>
                  <div>
                    <h3 className="text-white text-xl font-bold">{displayLastName} {displayFirstName} {displayPatronymic}</h3>
                    <p className="text-blue-200">ID: {userId}</p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-500/20 text-green-200 text-xs rounded-full">
                        <CheckCircle className="w-3 h-3" /> Верифицирован
                      </span>
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-yellow-500/20 text-yellow-200 text-xs rounded-full">
                        <Star className="w-3 h-3" /> PRO
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="p-6 space-y-4">
                {/* Phone */}
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center">
                      <Phone className="w-5 h-5 text-violet-600" />
                    </div>
                    <div>
                      <p className="text-xs text-slate-500">Телефон</p>
                      <p className="text-slate-800 font-medium">{data.phone || '+7 (999) 123-45-67'}</p>
                    </div>
                  </div>
                  <button className="p-2 text-slate-400 hover:text-violet-600 hover:bg-violet-50 rounded-lg">
                    <Edit2 className="w-4 h-4" />
                  </button>
                </div>
                
                {/* Email */}
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Mail className="w-5 h-5 text-blue-600" />
                    </div>
                    <div>
                      <p className="text-xs text-slate-500">Email</p>
                      <p className="text-slate-800 font-medium">{data.email || 'user@email.com'}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full">Подтверждён</span>
                    <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg">
                      <Edit2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                
                {/* Registration Date */}
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
                      <Calendar className="w-5 h-5 text-emerald-600" />
                    </div>
                    <div>
                      <p className="text-xs text-slate-500">Дата регистрации</p>
                      <p className="text-slate-800 font-medium">
                        {(() => {
                          // Random date between Sep 1, 2025 and Dec 30, 2025
                          const start = new Date(2025, 8, 1).getTime(); // Sep 1, 2025
                          const end = new Date(2025, 11, 30).getTime(); // Dec 30, 2025
                          const randomDate = new Date(start + Math.random() * (end - start));
                          return randomDate.toLocaleDateString('ru-RU', { 
                            day: 'numeric', 
                            month: 'long', 
                            year: 'numeric' 
                          });
                        })()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Security Settings */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-violet-100 rounded-xl flex items-center justify-center">
                  <Shield className="w-5 h-5 text-violet-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800">Безопасность</h3>
                  <p className="text-slate-500 text-sm">Настройки защиты аккаунта</p>
                </div>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center justify-between p-4 bg-green-50 border border-green-200 rounded-xl">
                  <div className="flex items-center gap-3">
                    <CheckCircle className="w-5 h-5 text-green-600" />
                    <div>
                      <p className="text-slate-800 font-medium">Двухфакторная аутентификация</p>
                      <p className="text-green-600 text-sm">Включена</p>
                    </div>
                  </div>
                  <button className="px-4 py-2 text-sm text-slate-600 hover:text-slate-800 border border-slate-200 rounded-lg">
                    Настроить
                  </button>
                </div>
                
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <Lock className="w-5 h-5 text-slate-400" />
                    <div>
                      <p className="text-slate-800 font-medium">Пароль</p>
                      <p className="text-slate-500 text-sm">Последнее изменение: 30 дней назад</p>
                    </div>
                  </div>
                  <button className="px-4 py-2 text-sm text-violet-600 hover:bg-violet-50 border border-violet-200 rounded-lg">
                    Изменить
                  </button>
                </div>
                
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <Monitor className="w-5 h-5 text-slate-400" />
                    <div>
                      <p className="text-slate-800 font-medium">Активные сессии</p>
                      <p className="text-slate-500 text-sm">1 устройство</p>
                    </div>
                  </div>
                  <button className="px-4 py-2 text-sm text-red-600 hover:bg-red-50 border border-red-200 rounded-lg">
                    Завершить все
                  </button>
                </div>
              </div>
            </div>

          </div>
        </main>
      </div>
      </div>
    </div>
  );
}
